module.exports = __webpack_public_path__ + "static/warrior_wall-a2df725323e5f8c591c672e67f29e37d.jpg";